import { render } from "./sidebar-icon.vue?vue&type=template&id=dd2c1b16&scoped=true"
import script from "./sidebar-icon.vue?vue&type=script&lang=js"
export * from "./sidebar-icon.vue?vue&type=script&lang=js"

import "./sidebar-icon.vue?vue&type=style&index=0&id=dd2c1b16&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2c1b16"]])

export default __exports__